/**
 * @file Re-exports the InvestmentFunding component.
 */
import InvestmentFunding from "./InvestmentFunding";

export default InvestmentFunding;
